import { axios } from 'utils/axios';

// SafetyNow chemical search endpoint
const searchChemicals = (query, pageNumber = 1) => {
    return axios.get(`/safetynow/search/${encodeURIComponent(query)}`, {
        params: { page_number: pageNumber }
    });
};

// SafetyNow chemical profile endpoint
const getChemicalProfile = (data) => {
    return axios.post('/safetynow/chemical/profile', data);
};

// UserSDS endpoints
const uploadSDS = (formData) => {
    return axios.post('/safetynow/usersds/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

const listSDS = (params = {}) => {
    return axios.get('/safetynow/usersds/list', { params });
};

const getSDS = (sdsId) => {
    return axios.get(`/safetynow/usersds/${sdsId}`);
};

const downloadSDS = (sdsId) => {
    return axios.get(`/safetynow/usersds/${sdsId}/original`, {
        responseType: 'blob'
    });
};

const updateSDS = (sdsId, data) => {
    return axios.put(`/safetynow/usersds/${sdsId}`, data);
};

const deleteSDS = (sdsId) => {
    return axios.delete(`/safetynow/usersds/${sdsId}`);
};

const processSDS = (sdsId, data) => {
    return axios.post(`/safetynow/usersds/${sdsId}/reprocess`, data);
};

export {
    searchChemicals,
    getChemicalProfile,
    uploadSDS,
    listSDS,
    getSDS,
    downloadSDS,
    updateSDS,
    deleteSDS,
    processSDS,
};
